import { render, staticRenderFns } from "./BranchTeam.vue?vue&type=template&id=fae53d28&scoped=true"
import script from "./BranchTeam.vue?vue&type=script&lang=js"
export * from "./BranchTeam.vue?vue&type=script&lang=js"
import style0 from "./BranchTeam.vue?vue&type=style&index=0&id=fae53d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae53d28",
  null
  
)

export default component.exports